import { useSelector } from "react-redux";
import { CONSENT_TYPES, markConsentAccepted } from "../../Services/Consent";
import useConsentPoint from "../../Components/Home/Crm2/TermsGate";

const formatINR = (value) => `₹ ${Number(value || 0).toLocaleString("en-IN")}`;

// Summary rows shown at the top of the consent popup
export const tokenConsentSummary = (token) => [
	["Payment for", "Token"],
	["Token", token?.eventTokenId?.tokenId?.name || "-"],
	["Amount", formatINR((token?.amount || 0) - (token?.paidAmount || 0))],
];

export const allotmentConsentSummary = (allotment) => {
	const unit = allotment?.unitId;
	const unitLabel =
		[unit?.inventoryTypeId?.type, unit?.floorNo, unit?.saleableArea && `Area ${unit.saleableArea} sq.ft`]
			.filter(Boolean)
			.join(" · ") || "-";
	const total = allotment?.bookingAmt?.total;
	return [
		["Payment for", allotment?.isCrm2 ? "Booking amount" : "Allotment (booking amount)"], // M6-F9 (DC-75): CRM 2.0 wording
		["Unit", unitLabel],
		...(total ? [["Balance to pay", formatINR(Math.max(total - (allotment?.paidAmount || 0), 0))]] : []),
	];
};

// requireConsent(type, action, { summary, allotmentPaymentId })
// CRM 2.0 M3-F11 (DC-117 / DC-169): same screens and callers as before, but the server decides what to ask
// (consent point pay_token / pay_booking / view_va), sends and checks the OTP and saves the consent.
// - nothing to accept → action() runs straight away
// - otherwise the terms + OTP pop-up is shown, then action() runs
const POINT = { [CONSENT_TYPES.TOKEN]: "pay_token", [CONSENT_TYPES.ALLOTMENT]: "pay_booking", [CONSENT_TYPES.VIRTUAL_ACCOUNT]: "view_va" };

export default function usePaymentConsent() {
	const loggedInUser = useSelector((state) => state.Auth.user);
	const { requirePoint, termsModal } = useConsentPoint();

	const requireConsent = (type, action, { summary = [], allotmentPaymentId = null } = {}) =>
		requirePoint(
			POINT[type] || type,
			allotmentPaymentId,
			() => {
				// keeps every screen (Pay Now, VA card, VA pop-up) in step, as before
				markConsentAccepted(loggedInUser?.leadId, type);
				action();
			},
			{ summary },
		);

	return { requireConsent, consentModal: termsModal };
}
